import React, { Suspense, lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import SiteHeader from "@/components/common/SiteHeader";
import { z } from "zod";

// Wave-17 Item 1.1 — Staff submissions list lazy-loaded.
const SubmissionsList = lazy(() => import("@/pages/Staff/SubmissionsList/Page"));

export const StaffListPage = () => (
  <div className="flex flex-col w-full min-h-full">
    <SiteHeader header="Staff List" />
    <Suspense fallback={null}>
      <SubmissionsList />
    </Suspense>
  </div>
);

export const Route = createFileRoute("/staff/")({
  component: StaffListPage,
  validateSearch: z.object({
    status: z
      .string()
      .default("all")
      .transform((val) => {
        const cleaned = val.replace(/^"|"$/g, "");
        if (cleaned === "all" || /^\d+$/.test(cleaned)) return cleaned;
        return "all"; // fallback!
      }),
    filingType: z.string().optional().default("all"),
    paid: z.string().optional().default("all"),
    q: z.string().optional().default(""),
  }),
});
